export default __webpack_public_path__ + "static/media/usclogo.e7aa40fd.jpg";